<div class="task-modal-single">

  <!-- Header -->
  <div class="row align-items-center">
    <div class="col">
      <h3 class="text-manax m-0 mb-4 d-flex justify-content-between align-items-center">
        <!-- Título y pill a la izquierda -->
        <span class="d-flex align-items-center">
          <span class="text-purple-manax text-capitalize title-modal" #top>
            Trabajo
          </span>
          <span class="status-pill status-label ml-3"
            [ngStyle]="{'background-color': taskStatusColors[task.status || ''] || taskStatusColors.DEFAULT}"
            *ngIf="action !== 'Crear'">
            {{ taskStatuses[task.status || ''] }}
          </span>
        </span>
        <!-- Botones a la derecha -->
        <span class="d-flex align-items-center">
          <button mat-raised-button type="button" class="btn btn-outline-manax button-edit mr-2"
            (click)="openEditTaskModal(task)">
            <i class="material-icons">edit</i> Editar
          </button>
          <span class="redirect pr-2">
            Ir a
            <a class="text-manax cursor-pointer" (click)="redirectToCalendar()">
              Agenda
            </a>
          </span>
          <button mat-icon-button type="button" (click)="closeModal()">
            <i class="material-icons">close</i>
          </button>
        </span>
      </h3>
    </div>
  </div>


  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- body content -->
  <div *ngIf="!loading">
    <div class="row font-manax split-border">
      <div class="col-12 col-md-8">
        <div class="row px-3 pb-3 text-purple-manax bold-item" style="font-size: 2rem;">{{task.client?.firstname}}
          {{task.client?.lastname}}
        </div>
        <div class="row px-3 pb-2 text-purple-manax bold-item" style="font-size: 1.5rem;">{{task.title}}</div>
        <div class="row px-3 pb-2 bold-item">Categoría:
          <span class="normal-item">&nbsp;{{task.category?.[0]?.name}}</span>
        </div>
        <div class="row px-3 pb-2 bold-item" *ngIf="task?.description">Instrucciones:
          <span class="normal-item">&nbsp;{{task.description}}</span>
        </div>
        <div class="row px-3 pb-2 bold-item">Ubicación:
          <span class="normal-item">&nbsp;{{task.location}}</span>
        </div>
        <div class="row px-3 pb-2 bold-item" *ngIf="filteredWorkers.length > 0">Trabajadores:
          <span *ngFor="let worker of filteredWorkers; let isLast=last" class="normal-item">
            &nbsp;{{worker?.firstname}} {{worker?.lastname}}{{!isLast ? ', ' : ''}}
          </span>
        </div>
        <div class="row px-3 pb-2 bold-item">Fecha Visita:
          <span class="normal-item">&nbsp;{{dateRange}}</span>
        </div>
      </div>
      <div class="col-12 col-md-4 split-border-detail">
        <div class="row px-3 pb-1 pb-md-3 text-purple-manax bold-item" style="font-size: 2rem;">&nbsp;</div>
        <div class="row px-3 pb-2 bold-item" style="font-size: 1.5rem;">Detalles</div>
        <div class="row px-3 pb-2 bold-item">Tipo de Trabajo:
          <span class="normal-item">&nbsp;{{task.appointment?.schedule ? 'Recurrente' : 'Eventual'}}</span>
        </div>


        <div class="row px-3 pb-2 bold-item">Inicio:
          <span class="normal-item">&nbsp;{{startDate}}</span>
        </div>
        <div class="row px-3 pb-2 bold-item">Fin:
          <span class="normal-item">&nbsp;{{untilDate}}</span>
        </div>


        <div class="row px-3 pb-2 bold-item" *ngIf="recuFreq">Programación:
          <span class="normal-item">&nbsp;{{recuFreq}}</span>
          <span class="normal-item" *ngIf="recuDay && !recuInterval">&nbsp;Los {{recuDay}} de cada mes</span>
          <span class="normal-item" *ngIf="recuDay && recuInterval">&nbsp;Los días {{recuDay}} cada {{recuInterval}}
            meses</span>
          <span class="normal-item" *ngIf="recuWeek && !recuInterval">&nbsp;{{ recuWeek.join(', ') }}</span>
          <span class="normal-item" *ngIf="recuWeek && recuInterval">&nbsp;{{ recuWeek.join(', ') }} cada
            {{recuInterval}} semanas</span>
        </div>

        <div class="row px-3 pb-2 bold-item" *ngIf="task.quote?.number">
          Generado desde Presupuesto Nro:
          <span class="normal-item">&nbsp;{{ task.quote?.number }}</span>
        </div>

      </div>
    </div>

    <div class="row my-3">
      <div class="col-12 text-center">
        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-outline-danger"
          (click)="openDeleteTaskConfirm()" *ngIf="readOnly && task?.status != 'CANCELLED'">
          Eliminar
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-outline-manax"
          (click)="openNewCommentModal()" *ngIf="readOnly">
          <i class="material-icons">maps_ugc</i>&nbsp;<span class="d-none d-lg-inline">Notas y adjuntos</span>
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-outline-manax"
          (click)="openMovementsModal()" *ngIf="readOnly">
          <i class="material-icons">access_time</i>&nbsp;<span class="d-none d-lg-inline">Fichajes</span>
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-outline-manax"
          (click)="openShareModal()" *ngIf="readOnly">
          <i class="material-icons">share</i>&nbsp;<span class="d-none d-lg-inline">Compartir</span>
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-outline-manax"
          (click)="openDuplicateTaskModal(task)" *ngIf="readOnly">
          <i class="material-icons">difference</i>&nbsp;<span class="d-none d-lg-inline">Duplicar</span>
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-outline-manax"
          (click)="openNextAppointmentModal(task)" *ngIf="readOnly && haveRecurrence">
          <i class="material-icons">next_week</i>&nbsp;<span class="d-none d-lg-inline">Proximas visitas</span>
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-outline-manax"
          (click)="openDeliveryNote()" *ngIf="(task?.status == 'COMPLETED' || task?.status == 'INVOICED') && readOnly">
          <span *ngIf="task.deliverynote">
            <i class="material-icons">description</i>&nbsp;<span class="d-none d-lg-inline">Ver Albarán</span>
          </span>
          <span *ngIf="!task.deliverynote">
            <i class="material-icons">description</i>&nbsp;<span class="d-none d-lg-inline">Crear Albarán</span>
          </span>
        </button>

        <!-- <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-manax" (click)="openInvoice()"
          *ngIf="(task?.status == 'INVOICED') && readOnly">
          Ver&nbsp;Factura
        </button> -->

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-manax" (click)="invoiceTask()"
          *ngIf="(task?.status == 'COMPLETED') && readOnly && !task?.serviceAgreement?._id">
          Facturar
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-manax" (click)="setStatusCompleted()"
          *ngIf="(task?.status == 'SCHEDULED' || task?.status == 'ONGOING') && readOnly">
          Completar
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-manax" (click)="openInvoice()"
          *ngIf="(task?.status == 'INVOICED')">
          Ver&nbsp;Factura
        </button>

      </div>
    </div>

    <!-- <div class="row my-3 font-manax" *ngIf="timeTracks?.length > 0">
      <div class="col-12">
        <div class="row">
          <h5 class="col-12 m-0 pt-3 bold-item">
            Fichajes:
          </h5>
        </div>
        <div class="row">
          <div class="d-none d-md-flex col-md-4 justify-content-center bold-item">
            Trabajador
          </div>
          <div class="d-none d-md-flex col-md-4 justify-content-center bold-item">
            Tiempo Trabajado
          </div>
          <div class="d-none d-md-flex col-md-4 justify-content-center bold-item">
            Tiempo Descanso
          </div>
        </div>
        <ng-container *ngFor="let tt of timeTracks">
          <div class="row" *ngIf="tt !== undefined">
            <div class="col-12 col-md-4 m-0 pt-1 text-left text-md-center">
              <span class="d-block d-md-none bold-item">Trabajador:&nbsp;</span>{{tt.workerName}}
            </div>
            <div class="col-12 col-md-4 m-0 pt-1 text-left text-md-center" *ngIf="tt.totalworked > 0">
              <span class="d-block d-md-none bold-item">Tiempo Trabajado:&nbsp;</span>{{tt.formatTotalworked}}
            </div>
            <div class="col-12 col-md-4 m-0 pt-1 text-left text-md-center" *ngIf="tt.totalbreak > 0">
              <span class="d-block d-md-none bold-item">Tiempo Descanso:&nbsp;</span>{{tt.formatTotalbreak}}
            </div>
          </div>
        </ng-container>
      </div>
    </div> -->

    <div class="row my-3 font-manax" *ngIf="comments && comments?.length > 0">
      <div class="col-12">
        <h5 class="m-0 pt-3 bold-item">
          Notas y adjuntos:
        </h5>
        <div>
          <div *ngFor="let item of comments" class="m-0 p-0">
            <b *ngIf="item.worker">{{ item.worker?.firstname }} {{ item.worker?.lastname }}&nbsp;</b>
            <b *ngIf="!item.worker">{{ item.user?.username }}&nbsp;</b>
            <b class="small">({{ item.createdAt | date: 'dd/MM/yyyy HH:mm' }}):</b>&nbsp;
            <span>{{ item.comment }}</span>
            <ng-container *ngIf="item.attachments?.length > 0">
              <br>
              <ng-container *ngFor="let file of item.attachments">
                <!-- Validar luego si es una imagen con todos sus tipos de formato o no -->
                <img *ngIf="(file.fileUrl).substring(file.fileUrl.length - 3) !== 'pdf'"
                  class="image-preview cursor-pointer" [src]="file.fileUrl" (click)="openFile(file)" />
                <img *ngIf="(file.fileUrl).substring(file.fileUrl.length - 3) == 'pdf'"
                  class="image-preview cursor-pointer" src="/assets/img/pdf-image.png" (click)="openPdf(file)" />
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="row font-manax py-3">
      <div class="col-12">
        <h5 class="m-0 title-section">
          Conceptos a facturar
        </h5>
      </div>

      <div class="col-12" *ngIf="task.products">
        <!-- taxPercentage: for compatibility with old tasks -->
        <app-detail-list [items]="detailItems" (listChange)="onListChange($event)"
          [readOnly]="!!task.serviceAgreement || readOnly" [pricing]="!task.serviceAgreement?._id"
          [taxPercentage]="task.taxPercentage ?? 0"></app-detail-list>
      </div>
    </div>

    <div class="row font-manax py-3" *ngIf="!task?.serviceAgreement?._id">
      <div class="col-12">
        <h5 class="m-0 title-section">
          Gastos
        </h5>
      </div>

      <div class="col-12">
        <!-- taxPercentage: for compatibility with old tasks -->
        <app-detail-list-expenses [items]="safeExpenses" (listChange)="onListChange($event)"
          [readOnly]="!!task.serviceAgreement || readOnly" [pricing]="!task.serviceAgreement?._id"
          [taxPercentage]="task.taxPercentage ?? 0"></app-detail-list-expenses>
      </div>
    </div>

    <div class="row py-3 font-manax" *ngIf="!task?.serviceAgreement?._id">
      <div class="col-12">
        <h5 class="m-0 pb-1 title-section">Rentabilidad neta (sin impuestos)</h5>
        <div class="row align-items-center justify-content-center">
          <div class="profitability-title col-1 p-0 d-flex align-items-center justify-content-center">
            Facturado
          </div>
          <div class="col-1 p-0 d-flex align-items-center justify-content-center">

          </div>
          <div class="profitability-title col-1 p-0 d-flex align-items-center justify-content-center">
            Costos
          </div>
          <div class="col-1 p-0 d-flex align-items-center justify-content-center">

          </div>
          <div class="profitability-title col-1 p-0 d-flex align-items-center justify-content-center">
            Gastos
          </div>
          <div class="col-1 p-0 d-flex align-items-center justify-content-center">

          </div>
          <div class="profitability-title col-1 p-0 d-flex align-items-center justify-content-center">
            Beneficio
          </div>
          <div class="profitability-number col-2 d-flex align-items-center justify-content-center">
            {{ formatPercentage(task) }}
          </div>
        </div>
        <div class="row align-items-center justify-content-center">
          <div class="profitability-data col-1 p-0 d-flex align-items-center justify-content-center">
            {{task.subtotal || 0 | money : { needSymbol:true } }}
          </div>
          <div class="profitability-data col-1 p-0 d-flex align-items-center justify-content-center">
            -
          </div>
          <div class="profitability-data col-1 p-0 d-flex align-items-center justify-content-center">
            {{ (task.cost || 0) | money : { needSymbol:true } }}
          </div>
          <div class="profitability-data col-1 p-0 d-flex align-items-center justify-content-center">
            -
          </div>
          <div class="profitability-data col-1 p-0 d-flex align-items-center justify-content-center">
            {{ (task.totalExpenses || 0) | money : { needSymbol:true } }}
          </div>
          <div class="profitability-data col-1 p-0 d-flex align-items-center justify-content-center">
            =
          </div>
          <div class="profitability-data col-1 p-0 d-flex align-items-center justify-content-center">
            {{task.subtotal || 0 - (task.cost || 0) - (task.totalExpenses || 0) | money : { needSymbol:true } }}
          </div>
          <div class="profitability-title col-2  d-flex align-items-center justify-content-center">
            Margen
          </div>
        </div>
      </div>
    </div>

  </div>
</div>